import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { statisticsStyles } from '../../Styles/statisticsStyles';
import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import Loader from 'react-loader-spinner'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

@inject('statisticsStore')
@observer
class AdminStats extends React.Component {
    state = {
        tableHeader: [
            { name: 'Admin', allowSort: true, sortDirection: 1 },
            { name: 'Agent', allowSort: false, sortDirection: 1 },
            { name: 'Docs Assigned', allowSort: false, sortDirection: 1 }
        ]
    }

    renderTableHeader = () => {
        const { tableHeader } = this.state;
        const { classes } = this.props;
        return (
            <TableHead>
                {
                    tableHeader.map((row, index) => (
                        (
                            <TableCell className={classes.tableHeader} align="left">
                                <div style={{ display: 'flex' }}>
                                    {row.name}
                                    {row.allowSort ? (row.sortDirection === 1 ?
                                        <ReactSVG className={classes.sortIcons} src={Images.sort} onClick={(e) => this.sortList(-1, index, row.type)} /> :
                                        <ReactSVG className={classes.sortIcons} src={Images.reverseSort} onClick={(e) => this.sortList(1, index, row.type)} />)

                                        : null}
                                </div>
                            </TableCell>
                        )
                    ))
                }
            </TableHead>

        )
    }

    renderTableContent = () => {
        const { classes } = this.props;
        const { adminStats } = this.props.statisticsStore;
        return (

            <TableBody>
                {adminStats.map((row, index) => (
                    <TableRow key={row._id} className={classes.tableRow}>
                        <TableCell className={classes.tableData} align="left">{row.assignedBy.userFullName}</TableCell>
                        <TableCell className={classes.tableData} align="left">{row.assignedTo.userFullName}</TableCell>
                        <TableCell className={classes.tableData} align="left">{row.docCount}</TableCell>
                    </TableRow>
                ))}
            </TableBody>

        )
    }

    renderStatsTable = () => {
        const { classes,theme } = this.props;
        const { adminStats } = this.props.statisticsStore;

        return (
            adminStats.length > 0 ? <TableContainer style={{ height: '90%', backgroundColor: this.props.theme.palette.dark }} elevation={0} component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                    {this.renderTableHeader()}
                    {this.renderTableContent()}
            
                   
                
                </Table>
            </TableContainer>
            : <div className={classes.tableData} style={{ textAlign: 'left', width: '430px', height: '5vh',padding: '1vw',backgroundColor:theme.palette.newGray  }}>No Data found</div>
        )

    }

    render() {
        const { classes } = this.props;
        const { inProgress } = this.props.statisticsStore;
        if (inProgress)
            return (
                <div style={{ height: '100%' }}>
                    <div><Loader height={100} width={100} color={this.props.theme.palette.blue} className={classes.loading} timeout={100000} /></div>
                </div>
            )
        return (
            <div style={{ height: '100%' }}>
                <div >
                    <div className={classes.subHeading}>Admin Tasks</div>
                    <div>
                        {this.renderStatsTable()}
                    </div>
                </div>
            </div>

        )
    }
}

export default withStyles(statisticsStyles, { withTheme: true })(withRouter(AdminStats));
